if (window.Shopify.loadFeatures) {
  const setConsentStatus = (consented) => {
    window.Shopify.loadFeatures(
      [
        {
          name: 'consent-tracking-api',
          version: '0.1',
        },
      ],
      (error) => {
        if (error) {
          throw error;
        }

        Shopify.trackingConsent.setTrackingConsent(consented, () => {
          const customEvent = new CustomEvent('consent:set');

          document.dispatchEvent(customEvent);
        });
      },
    );
  };

  window.addEventListener('ucEvents', (event) => {
    if (event.detail && event.detail.event === 'consent_status') {
      if (event.detail.type === 'explicit') {
        const {
          'customCategory-a6d081d5-e8a1-4d0b-b273-09a916607194': marketingAllowed = true,
          marketing: analyticsAllowed = true,
        } = event.detail.ucCategory;

        window.theme.consent = event.detail;
        sessionStorage.setItem('uc_consent', JSON.stringify(event.detail));
        setConsentStatus({
          analytics: analyticsAllowed,
          marketing: marketingAllowed,
          preferences: true,
          sale_of_data: marketingAllowed,
        });
      }
    }
  });

  if (window.UC_UI?.isInitialized()) window.UC_UI.restartCMP();

  document.querySelectorAll('a[href="#show_privacy_settings"]').forEach((link) => {
    link.addEventListener('click', (event) => {
      event.preventDefault();
      window.UC_UI?.showSecondLayer();
    });
  });
}
